import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AdminApi } from "@lbsdk/*";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public adminAPI: AdminApi, public router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.adminAPI.isAuthenticated()) {
      // alert("admin not logged in");
      this.router.navigate(["/auth/login"]);
      return false;
    }
    return true;
  }
}
